import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { getDashBoardState, getProjectState } from "@/redux/store";
import { PricingDownloadModal } from "../Style";
import { dashboardActions } from "@/redux/stores/dashboardStore";
import { useCallback, useState } from "react";
import { useTranslation } from "next-i18next";
import { useGetUserInfoQuery } from "@/redux/api/userApi";
import dayjs from "dayjs";
import { message } from "antd";
import axios from "axios";

export default function TeamDowngradeModal({
  plan,
  period,
}: {
  plan: string;
  period: boolean;
}) {
  const showDowngradeModal = useAppSelector(
    (store) => getDashBoardState(store).showDowngradeModal
  );
  const [messageApi, contextHolder] = message.useMessage();
  const { t } = useTranslation("common");
  const { data: userInfo } = useGetUserInfoQuery();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();

  function extractRole(text: string) {
    if (text?.includes("Personal")) return "Personal";
    else if (text?.includes("Team")) {
      return "Team";
    } else if (text?.includes("Pro")) {
      return "Pro";
    } else if (text?.includes("Starter")) {
      return "Starter";
    }
  }

  const handleCancel = useCallback(() => {
    dispatch(
      dashboardActions.setShowDowngradeModal({ type: "team", value: false })
    );
  }, [dispatch]);

  const planStep = useAppSelector((store) => getProjectState(store).planStep);

  const handleOk = useCallback(async () => {
    setIsLoading(true);
    try {
      const periodKey = period ? "monthly" : "yearly";
      const step =
        plan === "personal" ? planStep.personalPlanStep : planStep.teamPlanStep;

      const url = "/api/user/subscriptions/downgrade";

      const subscriptionRes = await axios.post(url, {
        plan,
        step,
        periodKey,
      });

      let mins = [];
      if (plan === "personal") {
        mins = ["15mins", "30mins", "60mins"];
      } else {
        mins = ["30mins", "60mins", "90mins"];
      }

      if (window?.dataLayer?.push) {
        window.dataLayer.push({
          event: "begin_checkout",
          plan_period: periodKey,
          plan_name: plan,
          plan_detail: mins[step],
          plan_subscription: "downgrade"
        });
      }

      window.gtag('set', 'user_properties', {
        'purchase_plan_period': periodKey,
        'purchase_plan_name': plan,
        'purchase_plan_detail': mins[step],
      });

      console.log("downgrade subscriptionRes.data: ", subscriptionRes.data);
      messageApi.open({
        content: t("You have successfully reserved a downgrade."),
        type: "success",
      });
    } catch (error) {
      console.log("error: ", error);
      // Modal.error(error);
    } finally {
      handleCancel();
      setTimeout(() => {
        setIsLoading(false);
        handleCancel();
      }, 1000);
    }
  }, [handleCancel, messageApi, period, plan, planStep.personalPlanStep, planStep.teamPlanStep, t]);

  return (
    <PricingDownloadModal
      open={showDowngradeModal.team}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={isLoading}
      cancelText={t("Cancel downgrade")}
    >
      {contextHolder}
      {userInfo?.schedule && (
        <div className="content">
          <div className="text">
            <span>Your downgrade to </span>
            <span className="boldTxt">
              {t(extractRole(userInfo?.schedule?.plan))} -
              {t(period ? "Monthly" : "Yearly")}
            </span>
            <span> is scheduled to</span>
          </div>
          <div className="text">
            <span className="boldTxt">
              {dayjs(userInfo?.schedule?.stareDate).format("MMM DD, YYYY")}
            </span>
            . Until then, you can use your existing plan.
          </div>
        </div>
      )}
      {!userInfo?.schedule && (
        <div className="content">
          <div className="text">
            <span>Your downgrade to </span>
            <span className="boldTxt">
              {t(extractRole(userInfo?.plan))} -
              {t(period ? "Monthly" : "Yearly")}
            </span>
            <span> is scheduled to</span>
          </div>
          <div className="text">
            <span className="boldTxt">
              {dayjs(userInfo?.servicePeriodEnd).format("MMM DD, YYYY")}
            </span>
            . Until then, you can use your existing plan.
          </div>
        </div>
      )}
    </PricingDownloadModal>
  );
}
